import {OverlayTrigger, Tooltip} from "react-bootstrap";
import FontAwesome from "utils/FA";
import React from "react";
import PropTypes from 'prop-types';
import {faInfoCircle} from "@fortawesome/pro-solid-svg-icons/faInfoCircle";

const InfoTooltip = ({
    placement,
    icon,
    children,
    ...rest
  }) =>
  <OverlayTrigger placement={placement}
                  overlay={<Tooltip>{children}</Tooltip>}>
    <FontAwesome icon={icon} {...rest}/>
  </OverlayTrigger>;

InfoTooltip.propTypes = {
  ...FontAwesome.propTypes,
  placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  icon: PropTypes.object
};

InfoTooltip.defaultProps = {
  ...FontAwesome.defaultProps,
  icon: faInfoCircle,
  placement: 'right'
};

export default InfoTooltip;
